<template>
  <layout-guest>
    <v-form
      @submit.prevent="forgoPassword"
      v-model="formulario"
      autocomplete="off"
    >
      <main class="container-wrap-base">
        <div
          class="rectangle"
          :style="`background-image: linear-gradient(to bottom, ${entityConfig.backgroundGradienColorFrom}, ${entityConfig.backgroundGradienColorTo});`"
        >
          <div class="row">
            <div class="col-sm">
              <div class="group-5">
                <div class="row">
                  <v-col cols="11" sm="11" md="11" style="padding-top: 5%">
                    <p class="source-sans-pro-ligh">
                      {{ $t("login.olvido") }}
                    </p>
                  </v-col>
                </div>

                <div class="row">
                  <v-col cols="12" sm="12" md="12">
                    <label class="label-login">{{ $t("MSAUTH02") }}</label>
                    <v-text-field
                       :color="entityConfig.primaryColor"
                      
                      placeholder="Email"
                      outlined
                      dense
                      v-model="form.email"
                      :rules="[rules.required, rules.email]"
                    ></v-text-field>
                  </v-col>
                </div>

                <div class="row">
                  <v-col cols="12" sm="12" md="12" style="padding-bottom: 15%">
                    <v-btn
                      :style="`color: ${entityConfig.secondaryColor}`"
                      @click="forgoPassword"
                      depressed
                      :color="entityConfig.primaryColor"
                      :disabled="!formIsValid"
                      class="float-end m-2 v-btn-width-default rectangle-button"
                    >
                      {{ $t("login.recuperarContraseña") }}
                    </v-btn>
                  </v-col>
                </div>
              </div>
            </div>
          </div>
        </div>
        <overlay :visible="spinner" :opacity="0.8"></overlay>
        <confirm-dialog
          :visible="confirmDialog"
          @closed="confirmDialog = !confirmDialog"
        ></confirm-dialog>
      </main>
    </v-form>
  </layout-guest>
</template>

<style scoped lang="scss">
@import "./login.style";
</style>

<script>
import Api from "../../Services/index";

import ConfirmDialog from "./confirm_dialog.vue";
import LayoutGuest from "../../components/layouts/layout-guest.vue";
import Overlay from "../../components/layouts/overlay.vue";

export default {
  name: "App",
  components: { Overlay, ConfirmDialog, "layout-guest": LayoutGuest },
  data() {
    return {
      entityConfig: {},
      formulario: false,
      confirmDialog: false,
      spinner: false,
      form: {
        codNrbeEn: "",
        email: "",
      },
      rules: {
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return (
            pattern.test(value) ||
            "Debe ser una dirección de correo electrónico con formato correcto"
          );
        },
        required: (value) => !!value || "Este campo es requerido.",

        emailMatch: () => `The email and password you entered don't match`,
      },
    };
  },

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    this.$store.dispatch("login/set_codNrbeEn");
    this.form.codNrbeEn = sessionStorage.getItem("codNrbeEn");
  },

  computed: {
    formIsValid() {
      return this.formulario;
    },
  },

  methods: {
    async forgoPassword() {
      try {
        this.spinner = true;
        const formData = new FormData();

        formData.append("email", this.form.email);
        formData.append("codNrbeEn", this.form.codNrbeEn);

        const obj = Object.fromEntries(formData);
        await Api.post("/usuarios/credenciales", obj);
        this.confirmDialog = true;
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },
  },
};
</script>
